<template>
    <div class="main">
        <van-swipe @change="onChange" :autoplay="3000" :loop="true" style="height: 414px;">
            <van-swipe-item v-if="videoObj.id">
                <div class="play-count" @click="videoPlayFun" v-if="!isPlay">
                    <img :src="videoObj.url" class="swipe-img " />
                    <div class="play-icon">
                        <img class="play-img" src="@/assets/play.png" alt="">
                    </div>
                </div>

                <div class="video-play">
                    <videoPlay 
                        v-bind="options"
                        :poster='videoObj.url'
                        @play="swipeOnPlay" 
                        @pause="swipeOnPause"
                        ref="swipePlay"
                    />
                </div>

            </van-swipe-item>
            <van-swipe-item v-for="(image, index) in albumArr" :key="index">
                <img :src="image" class="swipe-img" />
            </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator">{{ current + 1 }}/{{videoObj.id ? albumArr.length + 1 : albumArr.length}}</div>
            </template>
        </van-swipe>
    </div>
</template>

<script>
    import 'vue3-video-play/dist/style.css'
    import { videoPlay } from 'vue3-video-play'
    export default {
        // 轮播组件
        name: 'VantSlide',
        components: {
            videoPlay
        },
        props: {
            videoObj: {
                type: Object,
                default: () => {},
                required: false
            },
            albumArr: {
                type: Array,
                default: () => [],
                required: false
            }
        },
        data() {
            return {
                current: 0,
                isPlay: false,
                onPlayCount: null,
                options: {
                    width: '100%', //播放器高度
                    height: '375px', //播放器高度
                    color: "#409eff", //主题色
                    title: '', //视频名称
                    src: "https://go.dreamwq.com/videos/IronMan.mp4", //视频源
                    muted: false, //静音
                    webFullScreen: false,
                    speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
                    autoPlay: true, //自动播放
                    loop: false, //循环播放
                    mirror: false, //镜像画面
                    ligthOff: false,  //关灯模式
                    volume: 0.3, //默认音量大小
                    control: true, //是否显示控制器
                },
                playObj: {}
            }
        },
        created() {
            // this.videoPlayFun() 
        },
        methods: {
            onChange(index) {
                this.current = index;
            },
            videoPlayFun() {
                this.$http.post('/base/media_play/' + this.videoObj.id).then(({ data: res }) => {
                    let data = res.data
                    
                    if(!res.success) {
                        this.$toast.fail(res.errorMessage);
                        return
                    }
                    this.isPlay = true
                    this.options.src = data
                    this.playObj = this.$refs.swipePlay
                })
                .catch((err) => console.log(err))
                .finally(()=>{this.$toast.clear()})
            },
            // 播放器停止播放
            swipeOnPause(e) {
                this.$emit('topSwipe', this.$refs.swipePlay)
            },
            swipeOnPlay() {
                this.$emit('topPlay')
            }
        },
        mounted() {

        },
        watch: {

        },
    }
</script>

<style>
    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 24px;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.5);
        height: 24px;
        padding: 0 10px;
        line-height: 24px;
        border-radius: 12px;
        color: #fff;
    }
    .van-nav-bar {
        background-color: #ff9966;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
    }
    .title {
        color: #fff;
        font-size: 20px;
    }
    #videoPlayer {
        width: 100%;
        height: 375px;
    }
    .vjs-big-play-button {
        left: 50% !important;
        top: 50% !important;
        margin-top: -1px;
        margin-left: -1.5;
    }

    .play-count {
        width: 100%;
        position: relative;
    }

    .play-icon {
        position: absolute;
        left: 50%;    /* 定位父级的50% */
        top: 50%;
        transform: translate(-50%,-50%); /*自己的50% */
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.5);
    }
    .play-img {
        width: 30px;
        height: 30px;
        position: absolute;
        left: 50%;    /* 定位父级的50% */
        top: 50%;
        transform: translate(-50%,-50%); /*自己的50% */
    }
    .swipe-img {
        width: 100%;
        height: 375px;
        display: flex;
    }
    .video-play {
        width: 100%;
    }
</style>
